import { render } from "./view_trustees.html?vue&type=template&id=7bb3e868&external"
import script from "./view_trustees.js?vue&type=script&lang=js&external"
export * from "./view_trustees.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__